import Marquee from "react-fast-marquee";

const ITEMS = [
  "POLICY AS CODE",
  "ZERO OUT-OF-POLICY EXECUTIONS",
  "DECISION LEDGER",
  "DETERMINISTIC REPLAY",
  "EARNED AUTONOMY",
  "ONE-ACTION ROLLBACK",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/10 bg-[#0A0A0B] py-5" data-testid="editorial-marquee">
      <Marquee speed={35} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8 font-mono text-xs uppercase tracking-[0.35em] text-zinc-500">
            {item}
            <span className="text-[#00FF41]">●</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
